// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.paixu {\n  float: none;\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n  margin-left: 50px;\n  margin-bottom: 10px;\n  margin-top: -30px;\n  color: #ffffff;\n}\n", ""]);
// Exports
module.exports = exports;
